module.exports = __webpack_public_path__ + "static/img/2c.9075465.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente/2c.png
// module id = DQ1w
// module chunks = 0